import React, { useState, useMemo } from 'react';
import Alert from 'components/ui/Alert';
import { Link } from 'react-router-dom';
import ArrowRightIcon from 'components/v2/icons/ArrowRightIcon';
export default function OrderRtbBanner({ order, className = '' }) {
    const [visible, setVisible] = useState(true);
    const { orderLinkHref, orderLinkText } = useMemo(() => {
        if (!order) {
            return { orderLinkHref: null, orderLinkText: null };
        }
        const orderObj = order;
        const orderId = typeof orderObj === 'object' ? orderObj === null || orderObj === void 0 ? void 0 : orderObj._id : orderObj;
        const linkText = typeof orderObj === 'object'
            ? (orderObj === null || orderObj === void 0 ? void 0 : orderObj.order_id) || (orderObj === null || orderObj === void 0 ? void 0 : orderObj._id)
            : orderObj;
        return {
            orderLinkHref: orderId ? `/orders/${orderId}` : null,
            orderLinkText: linkText || null,
        };
    }, [order]);
    if (!visible || !orderLinkHref || !orderLinkText) {
        return null;
    }
    return (React.createElement(Alert, { className: `mt-4 mb-4 ${className}`, type: "info", canClose: true, onClose: () => setVisible(false) },
        React.createElement("div", { className: "flex items-center gap-6" },
            React.createElement("span", null, "Invoice creation is now available directly from the Order Detail page"),
            React.createElement(Link, { to: orderLinkHref, className: "inline-flex items-center" },
                orderLinkText,
                React.createElement(ArrowRightIcon, { className: "ml-1 w-4 h-4" })))));
}
